var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"m-portlet m-portlet--full-height"},[_c('div',{staticClass:"m-portlet__body"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }